import { Component, EventEmitter, Injector, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { GridComponent, RowArgs } from '@progress/kendo-angular-grid';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { BoxContainerService } from 'src/app/box-container/box-container.service';
import { ItemService } from 'src/app/item/item.service';
import { PackagingService } from 'src/app/packaging/packaging.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { ContainerLookupCallFromTypeEnum, OrderTypeEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';
import { OrdersContainerItemListComponent } from '../orders-container-item-list/orders-container-item-list.component';
import { OrdersContainerItemMoveFormComponent } from '../orders-container-item-move-form/orders-container-item-move-form.component';
import { RetainModifiersDialogComponent } from '../retain-modifiers-dialog/retain-modifiers-dialog.component';

@Component({
    selector: 'app-orders-container-list',
    templateUrl: './orders-container-list.component.html',
    styleUrls: ['./orders-container-list.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    encapsulation: ViewEncapsulation.None,
})
export class OrdersContainerListComponent extends AppComponentBase implements OnInit {

    componentSubscriptions: Subscription = new Subscription();
    @ViewChildren('containerItems') containerItems:
        QueryList<OrdersContainerItemListComponent>;
    @ViewChild('containerListForm', { static: true }) containerListForm: NgForm;
    @ViewChild('grid', { static: false }) private grid: GridComponent;
    @Output() emitContainerDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitContainer: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitContainerQuantityAndValueChangeEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitRetainModifiersList: EventEmitter<any> = new EventEmitter<any>();

    @Input() set accountId(accountId: any) {
        if (accountId) {
            this.accId = accountId;
            this.onInitialLoad(false);
        }
    }
    @Input() containerList: any;
    @Input() isNewOrder: boolean;
    @Input() orderTypeId: number;
    @Input() isPanelExpended: boolean;
    @Input() readOnly: boolean;
    defaultPackaging: Array<any>;
    orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum;
    callFromTypeEnum: typeof ContainerLookupCallFromTypeEnum = ContainerLookupCallFromTypeEnum;
    customContainerList: Array<any>;
    containerListForFIlter: Array<any>;
    defaultPackagingForFIlter: Array<any>;
    containerId: any;
    totalLbs: any;
    totalValue: any;
    parentForm: any;
    retainModifiersData: any;
    orderDisplayValue: any;
    gridItems: any = {
        data: [],
        total: 0
    };
    accId: number;
    orderId: string;
    isAllExpanded = true;

    constructor(
        injector: Injector,
        private boxContainerServices: BoxContainerService,
        private commonService: CommonService,
        private itemService: ItemService,
        private packagingService: PackagingService,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        public commonMethod: CommonMethod,
        private ngForm: NgForm) {
        super(injector);
        this.parentForm = ngForm;
    }

    ngOnInit(): void {
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
        } else if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
        }
        this.onInitialLoad(true);
        this.getDefaultPackaging();
        this.componentSubscriptions.add(
            this.commonMethod.getOrderId.subscribe(data => {
                this.orderDisplayValue = data ? data : 0;
            })
        )
    }

    onInitialLoad(callInitialContainerLoad: boolean) {
        let queryString = '';
        queryString += `&callFrom=${this.callFromTypeEnum.order}&accountId=${this.accId}`;
        if (this.orderId) {
            queryString += `&orderId=${this.orderId}`;
        }
        if(this.accId) {
            this.boxContainerServices.getBoxContainerLookups(queryString).subscribe(response => {
                if (response.isSuccess) {
                    this.customContainerList = response.data;
                    this.containerListForFIlter = response.data;
                    this.gridItems.data.map(item => {
                        if (item.containerId) {
                            const findConatinerId = this.customContainerList.find(cLookup => cLookup.containerId === item.containerId);
                            if (!findConatinerId) {
                                item.containerId = null;
                            }
                        }
                    });
                    if (callInitialContainerLoad) {
                        this.initialContainerLoad();
                    }
                }
            });
        } else {
            this.boxContainerServices.getBoxContainerLookups('').subscribe(response => {
                if (response.isSuccess) {
                    this.customContainerList = response.data;
                    this.containerListForFIlter = response.data;
                    if (callInitialContainerLoad) {
                        this.initialContainerLoad();
                    }
                }
            });
        }
    }

    onExpandPanel(): void {
        this.isAllExpanded = !this.isAllExpanded;
        this.gridItems.data.map((item, index) => {
            item.isExpanded = this.isAllExpanded;
        });
    }

    initialContainerLoad() {
        if (this.containerList && this.containerList.length) {
            this.gridItems.data.push.apply(this.gridItems.data, this.containerList);
            this.gridItems.data.map((item, index) => {
                item.tempContainerId = index + 1;
                item.isExpanded = true;
                item.isFixedCost = item.containerId ?
                    this.customContainerList.find(cLookup => cLookup.containerId === item.containerId).isFixedCost
                    : false;
            });
        } else {
            this.gridItems.data.splice(0, 0, this.generateNewRow(null));
        }
    }

    isOpenConatinerItems(args: RowArgs) {
        return args.dataItem.isExpanded;
    }

    onContainerItemsCollapse(data: any) {
        data.dataItem.isExpanded = false;
    }

    onContainerItemsExpand(data: any) {
        data.dataItem.isExpanded = true;
    }

    onContainerQuantityChange(dataItem: any, rowIndex: string) {
        if (dataItem.quantity) {
            dataItem.isChanged = true;
            const quantityInNumber = parseInt(dataItem.quantity);
            if (!quantityInNumber) {
                this.gridItems.data[rowIndex].quantity = '1';
            }
            this.emitContainerQuantityAndValueChangeEvent.emit(this.gridItems);
        }
    }

    getDefaultPackaging(): void {
        this.packagingService.getPackagingLookup('').subscribe(response => {
            this.defaultPackaging = response.data;
            this.defaultPackagingForFIlter = response.data;
        });
    }

    onAddContainer() {
        this.gridItems.data.push(this.generateNewRow(null));
        this.containerListForm.form.markAsDirty();
    }

    onCopyAndCreateContainer(dataItem: any) {
        dataItem.isChanged = true;
        const validate = this.validateContainerForCopy(dataItem);
        if (validate) {
            const newContainer = this.commonService.objectDeepCopy(dataItem);
            newContainer.containerName = `Container ${this.gridItems.data.length + 1}`;
            newContainer.tempContainerId = this.gridItems.data.length + 1;
            newContainer.itemContainerId = null;
            newContainer.previousContainerId = null;
            newContainer.previousPackagingId = null;
            newContainer.copiedItemContainerId = dataItem.itemContainerId;
            newContainer.lineItems.map(item => { item.lineItemId = null; });
            this.gridItems.data.push(newContainer);
            this.containerListForm.form.markAsDirty();
            this.emitContainerQuantityAndValueChangeEvent.emit(this.gridItems);
        }
    }

    generateNewRow(items): any {
        const commonDataModel = new CommonDataModel();
        const containerModel = commonDataModel.quickQuoteContainerModel;
        containerModel.containerName = `Container ${this.gridItems.data.length + 1}`;
        containerModel.quantity = 1;
        containerModel.containerId = null;
        containerModel.tempContainerId = this.gridItems.data.length + 1;
        containerModel.isExpanded = true;
        containerModel.packagingId = null;
        containerModel.description = '';
        containerModel.lineItems = (items) ? items : [this.getEmptyItem()];
        containerModel.containerTotals = Object.assign({}, commonDataModel.containerTotalsModel);
        return containerModel;
    }

    validateContainerForCopy(dataItem: any): boolean {
        if (!dataItem.containerName) {
            this.toastr.warning('Please fill Container name to copy');
            return false;
        }
        return true;
    }

    onAddNewItem(event: any, containerName: any) {
        const containerItems = event._results.find(item => item.containerId === containerName).gridItems.data;
        containerItems.push(this.getEmptyItem());
        this.containerListForm.form.markAsDirty();
    }

    onSetDefaultContainerAndPackaging(data: any) {
        if (data && (data.weight || data.value)) {
            if (this.gridItems.data && this.gridItems.data.length && this.gridItems.data[data.containerId - 1].ContainerAutoSelected !== false) {
                this.itemService.getItem(`Id=${data.dataItem.itemId}&value=${data.value}&weight=${data.weight}`).subscribe(response => {
                    if (response.isSuccess && response.data) {
                        if (
                            response.data.thresholdCrateId &&
                            response.data.isThresholdContainer &&
                            ((response.data.weightThreshold <= data.weight) || (response.data.valueThreshold <= data.value)) && ((this.gridItems.data[data.containerId - 1].containerId) != response.data.thresholdCrateId)
                        ) {
                            this.commonService
                                .getConfirmationPopup(
                                    CommonConstants.crossedThresholdBoundaryConstants.crossedThresholdBoundary,
                                    CommonConstants.appComponent.no,
                                    CommonConstants.appComponent.yes
                                )
                                .then((result) => {
                                    if (result) {
                                        this.gridItems.data[data.containerId - 1].containerId = response.data.thresholdCrateId > 0 ? response.data.thresholdCrateId : null;
                                        this.gridItems.data[data.containerId - 1].packagingId = response.data.thresholdPackagingId > 0 ? response.data.thresholdPackagingId : null;
                                        this.gridItems.data[data.containerId - 1].ContainerAutoSelected = true;
                                    }
                                });
                        } else if (
                            response.data.defaultCrateId &&
                            !response.data.isThresholdContainer &&
                            ((response.data.weightThreshold >= data.weight) || (response.data.valueThreshold >= data.value)) && ((this.gridItems.data[data.containerId - 1].containerId) != response.data.defaultCrateId)
                        ) {
                            this.commonService
                                .getConfirmationPopup(
                                    CommonConstants.crossedThresholdBoundaryConstants.crossedDefaultBoundary,
                                    CommonConstants.appComponent.no,
                                    CommonConstants.appComponent.yes
                                )
                                .then((result) => {
                                    if (result) {
                                        this.gridItems.data[data.containerId - 1].containerId = response.data.defaultCrateId > 0 ? response.data.defaultCrateId : null;
                                        this.gridItems.data[data.containerId - 1].packagingId = response.data.defaultPackagingId > 0 ? response.data.defaultPackagingId : null;
                                        this.gridItems.data[data.containerId - 1].ContainerAutoSelected = true;
                                    }
                                });
                        }
                    }
                });
            }
        } else {
            if (this.gridItems.data && this.gridItems.data.length && this.gridItems.data[data.containerId - 1].ContainerAutoSelected !== false) {
                this.gridItems.data[data.containerId - 1].containerId = data.dataItem.defaultCrateId > 0 ? data.dataItem.defaultCrateId : null;
                this.gridItems.data[data.containerId - 1].packagingId = data.dataItem.defaultPackagingId > 0 ? data.dataItem.defaultPackagingId : null;
                this.gridItems.data[data.containerId - 1].ContainerAutoSelected = true;
            }
        }

    }

    onContainerChange(dataItem: any, containerId: number, callFrom?: string) {
        dataItem.isChanged = true;
        dataItem.ContainerAutoSelected = false;
        if (callFrom === 'container') {
            if (dataItem.copiedItemContainerId != null) {
                dataItem.isContainerChanged = true;
            }
            dataItem.isFixedCost = containerId ? this.customContainerList.find(item => item.containerId === containerId).isFixedCost : false;
            setTimeout(() => {
                this.emitContainer.emit(dataItem);
            }, 200);
        } else if (callFrom === 'packaging') {
            if (dataItem.copiedItemContainerId != null) {
                dataItem.IsPackagingChanged = true;
            }
        }
        if (callFrom === 'container' && dataItem.previousContainerId != null && dataItem.isChanged && this.orderDisplayValue > 0 && containerId) {
            this.getRetainCategories(dataItem);
        }
    }

    onShowRetainModifiersPopup(containerId: any): void {
        this.dialog.open(RetainModifiersDialogComponent, {
            panelClass: 'medium_layout',
            hasBackdrop: false,
            data: {
                containerId: containerId
            },
        }).afterClosed()
            .subscribe((response: {}) => {
                if (response) {
                    this.retainModifiersData = response;
                    this.emitRetainModifiersList.emit(response);
                }
            })
    }

    getRetainCategories(dataItem: any): void {
        let isRetainAdded = false;
        this.commonService.getRetainCategoriesList(this.orderDisplayValue, dataItem.itemContainerId).subscribe((response: any) => {
            response.data[0].retainCategories.forEach(category => {
                if (category.selectedItem) {
                    isRetainAdded = true;
                    category.selectedItem = category.items.find(item => item.id === category.selectedItem.id);
                }
            });
            if (isRetainAdded) {
                this.onShowRetainModifiersPopup(dataItem.itemContainerId);
            }
        });
    }

    onContainerDescChange(dataItem: any) {
        dataItem.isChanged = true;
    }

    onRemoveDefaultContainerAndPackaging(data: any) {
        if (this.gridItems.data && this.gridItems.data.length && this.gridItems.data[data - 1].ContainerAutoSelected) {
            this.gridItems.data[data - 1].containerId = null;
            this.gridItems.data[data - 1].packagingId = null;
        }
    }

    getEmptyItem(): any {
        const commonDataModel = new CommonDataModel();
        const itemModel = commonDataModel.quickQuoteItem;
        itemModel.quantity = 1;
        itemModel.categoryId = null;
        itemModel.categoryName = null;
        itemModel.itemName = null;
        itemModel.itemId = null;
        itemModel.description = null;
        itemModel.isChanged = true;
        itemModel.length = 0;
        itemModel.width = 0;
        itemModel.height = 0;
        itemModel.weight = 0;
        itemModel.value = 0;
        itemModel.extlbs = 0;
        itemModel.extValue = 0;
        itemModel.nmfcClass = '85';
        itemModel.isOrientationLocked = false;
        itemModel.isActive = true;
        return itemModel;
    }

    onDeleteContainer(rowIndex: number) {
        if (this.gridItems.data.length > 1) {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                panelClass: 'confirm_layout',
                hasBackdrop: false,
                data: {
                    message: 'Are you sure you want to delete the Container',
                    isShowTitle: true
                }
            }).afterClosed()
                .subscribe((response: { confirmResult: boolean }) => {
                    if (response && response.confirmResult === true) {
                        this.gridItems.data.splice(rowIndex, 1);
                        this.gridItems.data.map((container, index) => container.containerName = `Container ${index + 1}`);
                        this.containerListForm.form.markAsDirty();
                        this.emitContainerItem();
                        this.emitContainerQuantityAndValueChangeEvent.emit(this.gridItems);
                        return;
                    }
                    return;
                });
        } else {
            this.toastr.warning('Cannot Delete Container');
        }
    }

    reFormateContainerData(containerId, selectedItems) {
        this.gridItems = {
            ...this.gridItems,
            data: this.gridItems.data.filter((container, containerIndex) => {
                if (container.tempContainerId === containerId) {
                    container.lineItems = [...container.lineItems, ...selectedItems];
                }
                container.lineItems = container.lineItems.filter(item => !item.isSelected);
                return container.lineItems.length;
            }),
        };
        this.gridItems.data.map((container, index) => container.containerName = `Container ${index + 1}`);
        this.gridItems.data = _.cloneDeep(this.gridItems.data);
    }

    onMoveItemContainer(data: any) {
        let selectedItems = [];
        const containersDropdown = [{ label: 'New Container', id: 0 }];
        this.gridItems.data.map((container, containerIndex) => {
            const currentSelected = _.cloneDeep(container.lineItems).filter(item => {
                if (item.isSelected) {
                    item.isSelected = false;
                    return item;
                }
            });
            selectedItems = [...selectedItems, ...currentSelected];
            if (currentSelected.length === 0) {
                containersDropdown.push({ label: container.containerName, id: container.tempContainerId });
            }
        });
        if (selectedItems.length > 0) {
            this.dialog.open(OrdersContainerItemMoveFormComponent, {
                position: {
                    right: '0',
                },
                panelClass: 'small_layout',
                hasBackdrop: false,
                data: { containers: containersDropdown, items: selectedItems },
            }).afterClosed().subscribe((response: any) => {
                if (response && response.confirmResult === true) {
                    if (response.selectedContainer === 0) {
                        this.gridItems.data.push(this.generateNewRow(selectedItems));
                        this.reFormateContainerData(null, null);
                    } else {
                        this.reFormateContainerData(response.selectedContainer, selectedItems);
                    }
                }
            });
        } else {
            this.toastr.error('Please select Item to be Moved.');
        }

    }

    emitContainerItem() {
        this.emitContainerDetails.emit();
    }

    getContainerActionTooltip() {
        if (this.gridItems.data.length > 1) {
            return 'Delete Container, Move Item';
        } else {
            return 'Move Item';
        }
    }

    handleFilter(value: any) {
        this.customContainerList = this.containerListForFIlter.filter((s) => s.containerName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    handlePackagingFilter(value: any) {
        this.defaultPackaging = this.defaultPackagingForFIlter.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }

    emitItemQuantityAndValueChangeEvent(data: any) {
        this.emitContainerQuantityAndValueChangeEvent.emit(this.gridItems);
    }

    ngOnDestroy(): void {
        this.componentSubscriptions.unsubscribe();
    }
}
